/**
 * Controls whether or not we show the insider marketing page to logged out retailers
 */
export const INSIDER_LOGGED_OUT_LANDING_PAGE_ONLY_240717 = 'INSIDER_LOGGED_OUT_LANDING_PAGE_ONLY_240717';
